<section class="grid-x {{article().attributes.bg}}-content">
    <div class="container temp-spacer grid-x">
        <article [@loadTrigger]="'inLeft'" class="article__main cell large-8">
            <h3>{{article().attributes.title}}</h3>
            <p>{{article().attributes.content}}</p>
        </article>
        <aside class="cell large-4"> image here</aside>
    </div>
</section>
